import { useState } from "react";
import { Mail, ChevronDown, MailPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtDateTime } from "@/lib/api";
import { useFetch } from "@/lib/hooks";
import { Panel, EmptyState } from "@/components/core/AppLayout";
import { AiEmailDialog } from "@/components/ai/AiEmailDialog";

const Row = ({ e }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#5FB3EA]/60 last:border-0 py-3" data-testid={`client-email-${e.id}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 text-left">
        <Mail className="h-4 w-4 text-[#E8173A] shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="font-bold text-[#0A1128] truncate">{e.oggetto}</div>
          <div className="text-xs text-slate-600 truncate">{fmtDateTime(e.sent_at)} · a {e.to.join(", ")}{e.cc?.length ? ` · CC ${e.cc.length} soci` : ""} · da {e.sent_by_nome}</div>
        </div>
        <span className={`text-[11px] font-bold rounded-full px-2 py-0.5 ${e.status === "inviato" ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-[#C8102E]"}`}>{e.status}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="mt-2 ml-7 whitespace-pre-wrap text-sm text-[#0A1128] bg-[#A6DAFC] rounded-xl p-3">{e.corpo}{e.error && <div className="text-[#C8102E] font-semibold mt-2">{e.error}</div>}</div>}
    </div>
  );
};

export const ClientEmails = ({ client }) => {
  const { data, reload } = useFetch(`/clients/${client.id}/email`);
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-4" data-testid="client-emails">
      <div className="flex justify-between items-center">
        <h3 className="font-display text-xl font-extrabold text-[#0A1128]">Email inviate</h3>
        <Button onClick={() => setOpen(true)} className="rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="client-emails-new"><MailPlus className="h-4 w-4 mr-1.5" />Scrivi email con AI</Button>
      </div>
      <Panel className="px-6 py-2">
        {data && !data.length ? <EmptyState icon={Mail} title="Nessuna email inviata" text="Scrivi la prima email al cliente con l'aiuto dell'AI." testid="client-emails-empty" /> : (data || []).map((e) => <Row key={e.id} e={e} />)}
      </Panel>
      <AiEmailDialog open={open} onOpenChange={setOpen} client={client} onSent={reload} />
    </div>
  );
};
